import React from 'react'
import FrontWall from './FrontWall'
import BackWall from './BackWall'
import LeftWall from './LeftWall'
import RightWall from './RightWall'
import { params } from '../../../../../../redux/reducers/reducer'

const Wall = () => {
    return (
        <>
            {params.rightLeanStoragePosition !== params.leanR_p_d - parseInt(params.add_storage_right) && <FrontWall/>}
            {params.rightLeanStoragePosition !== 0 && <BackWall/>}
            <LeftWall/>
            <RightWall/>
        </>
    )
}

export default Wall